import PropTypes from 'prop-types';
import SoftwareCard from '../SoftwareCard/SoftwareCard';
import styles from './SoftwareCardList.module.scss';
import Button from '../Button';

const SoftwareCardList = ({ title, items, link }) => {
    return (
        <div className={styles['SoftwareCardList']}>
            <div className={styles['SoftwareCardList__Container']}>
                <div className={styles['SoftwareCardList__Row']}>
                    <h2 className={styles['SoftwareCardList__Title']}>
                        {title}
                    </h2>
                    {link && link.href && <Button link={link} type={'tertiary'} icon={'arrow'} />}
                </div>
                <div className={styles['SoftwareCardList__List']}>
                    {items &&
                        items.map((item, i) => (
                            <div
                                key={i}
                                className={styles['SoftwareCardList__Item']}>
                                <SoftwareCard {...item} />
                            </div>
                        ))}
                </div>
            </div>
        </div>
    );
};

SoftwareCardList.propTypes = {
    title: PropTypes.string,
    items: PropTypes.array,
    link: PropTypes.object,
};

SoftwareCardList.defaultProps = {
    title: '',
    items: [],
    link: {},
};

export default SoftwareCardList;
